module.exports = __webpack_public_path__ + "img/spectacle.b4143319.png";